import { SectionContainer } from "@silversea-ssc/ui-components-react"
import React from "react"
import clsx from "clsx"
import styles from "./InnerSectionContainer.module.scss"

type Props = React.ComponentProps<typeof SectionContainer>

const InnerSectionContainer: React.FC<Props> = ({ children, className, ...props }) => {
    return (
        <SectionContainer className={clsx(styles.override, className)} backgroundColor="transparent" {...props}>
            {children}
        </SectionContainer>
    )
}

export default InnerSectionContainer
